var React = require('react');

function EmailSignupSquiggle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M206.605 35.3695C174.447 15.0853 138.172 -4.07535 100.655 -11.706C68.612 -18.2231 57.5822 -7.3381 74.3799 21.3806C86.4103 41.9487 100.253 61.8565 114.765 80.742C116.077 82.4497 131.595 97.6113 130.457 101.786C128.534 108.837 59.674 86.1815 55.4037 85.1211C45.6026 82.6872 29.3028 76.7195 18.5462 78.4308C6.26827 80.3841 27.429 109.857 28.0343 110.788C36.2973 123.486 140.061 246.617 137.512 248.486C128.079 255.404 89.5158 236.498 82.5299 233.889C44.7483 219.778 8.14186 202.181 -30.1106 189.368C-54.0095 181.363 -95.4634 167.456 -110.881 195.207","strokeWidth":"41","strokeLinecap":"round","strokeLinejoin":"round"}));
}

EmailSignupSquiggle.defaultProps = {"width":"228","height":"246","viewBox":"0 0 228 246","fill":"none"};

module.exports = EmailSignupSquiggle;

EmailSignupSquiggle.default = EmailSignupSquiggle;
